import { defOp } from "./compile/emit.js";
import { NEW_OUT, SET } from "./compile/templates.js";
const [set, set2, set3, set4] = defOp(
  SET,
  "o,a",
  void 0,
  "o",
  1,
  NEW_OUT
);
export {
  set,
  set2,
  set3,
  set4
};
